export enum RouteType {
    SuperAdminRoute = 'SUPER_ADMIN_ROUTE',
    AdminRoute = 'ADMIN_ROUTE',
    UserRoute = 'USER_ROUTE',
    PublicRoute = 'PUBLIC_ROUTE',
    ExternalRedirect = 'EXTERNAL_REDIRECT',
    InternalRedirect = 'INTERNAL_REDIRECT',
    ModeratorRoute = 'MODERATOR_ROUTE',
}
